import queryClient from '../../../../ReactQuery/client';
import useToastedMutation from '../../../../ReactQuery/useToastedMutation';
import { post } from '../../../../redux/api';
import type { RollbackVcsGitHubOrgResponse } from '../../../../../shared/types/routes/internalTools/vcsGitHub';
import type { QueryResponse } from '../../../../ReactQuery/useQuery';

function rollbackVcsGitHubOrg(): Promise<QueryResponse<RollbackVcsGitHubOrgResponse>> {
  return post<Record<string, never>, RollbackVcsGitHubOrgResponse>('/api/internal-tools/vcs-github/rollback', {});
}

/**
 * Rolls the current org back to the legacy GitHub App path: disables the
 * import flag and removes its fossaCore connections. fossabot rows and
 * vcs-service are left untouched; re-running Migrate restores the org.
 */
export function useRollbackVcsGitHubOrg() {
  return useToastedMutation<QueryResponse<RollbackVcsGitHubOrgResponse>>({
    mutationFn: rollbackVcsGitHubOrg,
    successToastMessage: (response) =>
      response.data
        ? `Rolled back to legacy: removed ${response.data.deletedConnections} connections and ${response.data.deletedProjectConnections} project links.`
        : 'Rolled back to legacy.',
    errorToastMessage: 'Failed to roll the org back to legacy.',
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['internal-tools', 'vcs-github'] });
    },
  });
}
